<template>
    <a-menu class="left-menu" mode="inline" theme="light" :selectedKeys="selectedKeys" v-model:openKeys="openKeys"
        @click="onMenuClick">
        <template v-for="item in menuList" :key="item.key">
            <template v-if="!item.children">
                <a-menu-item :key="item.key">
                    <a>
                        <icon-font :type="`icon-${item.icon}`" v-if="item.icon" />
                        <a-badge :count="messageArr.filter(i => i.menuCode == item.menuCode)[0].menuMessageNum"
                            :overflow-count="99" :offset="[10, 0]"
                            v-if="messageArr.filter(i => i.menuCode == item.menuCode).length > 0">
                            <span>{{ item.name }}</span>
                        </a-badge>
                        <span v-else>{{ item.name }}</span>
                        <!-- <span :class="item.str == 1 ? 'firstClass' : ''">{{ item.name }}</span> -->
                    </a>
                </a-menu-item>
            </template>
            <template v-else>
                <sub-menu @click="sidemenu(item.name)" :menu-info="item" :key="item.key" :messageArr="messageArr" />
            </template>
        </template>
    </a-menu>
</template>

<script>
import { mapGetters } from "vuex";
import SubMenu from "@/layout/layoutPage/aside/SubMenu";
import { leftMenuConfigOptions } from "@/config/platformConfig";
import { showTopMenu } from "@/config/platformConfig";
import bus from "@/utils/bus";
import { getMenuList } from "@/utils/convertData";
import { messagesNum } from "@/api/companyService";


const getParentKey = (list, key) => {
    let parentKey = [];
    let listObj = list.find(v => v[leftMenuConfigOptions.keyField] === key);
    if (listObj) {
        parentKey.push(listObj[leftMenuConfigOptions.keyField]);
        if (listObj[leftMenuConfigOptions.parentField] !== leftMenuConfigOptions.rootValue) {
            parentKey.push(...getParentKey(list, listObj[leftMenuConfigOptions.parentField]))
        }
    }
    return parentKey;
}
export default {
    name: "LeftMenu",
    components: {
        SubMenu
    },
    data() {
        return {
            selectedKeys: [],
            openKeys: [],

            historyMenu: [],
            menuList: [],
            messageArr: [],
        }
    },
    created() {
        if (!showTopMenu) {
            this.getCurrentMenuList(leftMenuConfigOptions.rootValue);
        }
        this.$nextTick().then(() => {
            this.getSelectedKey();
            this.getOpenKeys();
        })
        

        console.log(this.menuListAll,727272);
    },
    mounted() {
        if (showTopMenu) {
            bus.$on('menuChange', this.getCurrentMenuList);
        }
        this.getMessageNum()
        this.filterData()

    },
    beforeUnmount() {
        if (showTopMenu) {
            bus.$off('menuChange', this.getCurrentMenuList);
        }
    },
    methods: {
        filterData() {
            let a = ''
            this.menuList.map(first => {
                a = Object.assign(first, { str: 1 })
                if (first.children) {
                    first.children.map(second => {
                        a = Object.assign(second, { str: 2 })
                        if (second.children) {
                            second.children.map(third => {
                                a = Object.assign(third, { str: 3 })
                            })
                        }
                    })
                }
            })

            console.log(a, 'aaa')
        },
        sidemenu() {
            // console.log(name)
        },
        onMenuClick(e) {
            let toPath = this.pathObject[e.key];
            // let repeat = this.gethistoryMenu.some(item=>item==toPath)
            // console.log(toPath)
            // if(repeat) return;
            // this.$store.dispatch('ADD_TAGS',toPath)
            const { path, hash } = this.$route;
            if (path !== toPath) {
                this.$router[hash ? 'replace' : 'push']({
                    path: toPath,
                    hash: ''
                });
            }
            // this.navList.forEach((item,i) => {
            //     this.historyMenu.push({
            //         name:item,
            //         path:this.navPath[i]
            //     })
            // });
        },
        getCurrentMenuList(key) {
            this.menuList = getMenuList({
                list: this.menuListAll,
                rootValue: key,
                keyField: leftMenuConfigOptions.keyField,
                parentField: leftMenuConfigOptions.parentField,
                nameField: leftMenuConfigOptions.nameField,
                pathField: leftMenuConfigOptions.pathField,
                urlPrefixField: leftMenuConfigOptions.urlPrefixField,
                menuCodeField: leftMenuConfigOptions.menuCodeField,
            });
            // console.log(key, this.menuList)
        },
        getSelectedKey() {
            let selectedObj = this.currentPathObj;
            if (selectedObj) {
                this.selectedKeys = [selectedObj[leftMenuConfigOptions.keyField]];
                bus.$emit('leftMenuChange', this.currentPathObj);
            }
        },
        getOpenKeys() {
            let selectedObj = this.currentPathObj;
            if (selectedObj) {
                this.openKeys = getParentKey(this.menuListAll, selectedObj[leftMenuConfigOptions.keyField]);
            }
        },
        getMessageNum() {
            this.getAction({
                url: messagesNum.messagesNum
            }).then(res => {
                this.messageArr = res
                // this.messageArr.indexOf(item.menuCode)
                // console.log(this.messageArr)
                // console.log('1', this.messageArr..indexOf('sys_integralSystem'))
            })
        }
    },
    computed: {
        ...mapGetters([
            "menuListAll",
            "pathObject",
            "navList",
            "navPath",
            "gethistoryMenu"
        ]),
        currentPathObj() {
            let fullPathArray = this.$route.fullPath.split('#');
            let currentPath = fullPathArray.pop().split('?')[0];
            return this.menuListAll.find(item => item[leftMenuConfigOptions.pathField] === currentPath);
        }
    },
    watch: {
        ['$route.fullPath']() {
            this.getSelectedKey();
            this.getOpenKeys();
        }
    },
}
</script>

<style scoped lang="less">
:deep(.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected){
    background-color: #0059B5;
}
:deep(.ant-menu-item-selected a, .ant-menu-item-selected a:hover){
    color:#fff ;
}
:deep(.ant-menu-submenu-title:hover){
    color:#000;
}
:deep(.ant-menu-item::after){
    border-right: none;
}
:deep(.ant-menu-item-selected .ant-badge) {
    color:#fff ;
}

.left-menu {
    border-right: 0;
}
:deep(.ant-menu-submenu-selected){
    color:#333333;
    //font-weight: bold;
}
</style>
